import { Table, Tbody } from '@chakra-ui/react'
import { useGetUser } from 'BrokerTsLib/src/hooks/useUser'

import { OrganizationLink, UserLink } from '@/components'
import { TableSection } from '@/components/Section/TableSection'
import { TableSectionRow } from '@/components/Section/TableSectionRow'


export const PpzAuthorizationUserInfo = ({ userId }: { userId: string }) => {
  const { data } = useGetUser(userId)
  const user = data?.data

  return <TableSection wide>
    <Table variant={'simple'} fontSize={'md'} borderRadius={8}>
      <Tbody>
        <TableSectionRow title="Uživatel" fontWeight='bold'>
          <UserLink userId={user?.userId} name={`${user?.firstName} ${user?.lastName}`} />
        </TableSectionRow>
        <TableSectionRow title="Organizace">
          <OrganizationLink ouId={user?.organizationUnitId} name={user?.organizationUnitName} />
        </TableSectionRow>
        <TableSectionRow title="Obec">
          {user?.addressCity}
        </TableSectionRow>
        <TableSectionRow title="Mobilní telefon">
          {user?.phoneNumber}
        </TableSectionRow>
        <TableSectionRow title="Email">
          {user?.email}
        </TableSectionRow>
      </Tbody>
    </Table>
  </TableSection>
}